module.exports = __webpack_public_path__ + "static/media/hand_doodle.952ff4ea.png";